<template>
  <Fragment>
    <FormSection :name="$t('orderForm.orderInfo')" :childrenCount="value.order_template_name ? 3 : 2">
      <StatusInfo :status="value.status" :isInvoiced="value.billing && value.billing.invoice_status == 'invoiced'" />

      <StaticInfo
        v-if="value.order_template_name"
        :name="$t('orderDetail.orderTemplateName')"
        :value="value.order_template_name"
      />
      <FormInput :name="$t('orderDetail.comment')" :value="value.comment" @input="updateComment" :disabled="disabled" />
    </FormSection>
    <FormSection>
      <StaticInfo :name="$t('orderDetail.createdAt')" :value="formattedFromDateTime(value.created_at)" />
      <StaticInfo :name="$t('orderDetail.lastUpdate')" :value="formattedFromDateTime(value.updated_at)" />
    </FormSection>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'

import FormInput from '@/components/Form/Input/index.vue'
import FormSection from '@/components/Form/Section/index.vue'
import StaticInfo from '@/components/Form/StaticInfo/index.vue'
import StatusInfo from '@/components/Orders/forms/sections/elements/StatusInfo.vue'
import dateUtils from '@/components/mixins/dateUtils'

export default {
  name: 'InfoSection',
  components: {
    FormInput,
    FormSection,
    Fragment,
    StaticInfo,
    StatusInfo,
  },
  mixins: [dateUtils],
  props: {
    value: { type: Object, required: true },
  },
  computed: {
    disabled() {
      if (this.value.status == 'open' || this.value.status == 'assigned') {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    updateComment(comment) {
      this.$emit('input', { ...this.value, comment })
    },
  },
}
</script>
